import { useFlag } from '../../../services/launchDarkly';
import type { Game } from '../../../stores/game/types';
import { GameCard } from '../GameCard';

import styles from './NumberedGameItem.module.scss';
import { RANK_NUMBERS } from './RankNumbers/rankNumbers';

export function NumberedGameItem({
  game,
  rank,
  rowHasJackpot,
  rowName,
}: {
  game: Game;
  rank: number;
  rowHasJackpot: boolean;
  rowName: string;
}) {
  const gameLabelFF = useFlag('game_labels_feat', false);
  const RankNumber = RANK_NUMBERS[rank];

  return (
    <div className={styles.item}>
      <div className={styles.rankContainer}>{RankNumber && <RankNumber className={styles.rank} />}</div>
      <div className={styles.card}>
        <GameCard
          carousel
          animated={false}
          game={game}
          gameLabelFF={gameLabelFF}
          rowHasJackpot={rowHasJackpot}
          rowName={rowName}
        />
      </div>
    </div>
  );
}
